import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "-6 -4 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-6 -4 30 30\" id=\"icon-chevron-right\">\r\n\t<path d=\"M5.32 6.99L.12 1.57c-.16-.17-.16-.34 0-.5l.94-.94c.18-.16.35-.17.5-.03l6.35 6.64c.06.06.09.14.09.25 0 .1-.03.19-.09.25l-6.35 6.64c-.17.16-.34.16-.5 0l-.94-.97c-.16-.17-.16-.33 0-.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol